export default __webpack_public_path__ + "static/media/twitch-rounded.74ab8de5.svg";